import { Stack, Typography } from '@mui/material';
import { FieldEditorSectionWithName } from 'components/FieldEditor/types/FieldEditorSection';
import React from 'react';

import { BooleanMeta } from './BooleanMeta';
import { ComputedMeta } from './ComputedMeta';
import { ImageMeta } from './ImageMeta';
import { SortableMeta } from './SortableMeta';

export function Meta({
  fieldName,
  field,
  setField,
}: FieldEditorSectionWithName) {
  const components = [];

  if (field.sortable) {
    components.push(<SortableMeta field={field} setField={setField} />);
  }

  if (field.type === 'boolean') {
    components.push(<BooleanMeta field={field} setField={setField} />);
  }

  if (field.type === 'computed') {
    components.push(<ComputedMeta field={field} setField={setField} />);
  }

  if (fieldName === 'image' && field.type === 'image') {
    components.push(
      <ImageMeta fieldName={fieldName} field={field} setField={setField} />,
    );
  }

  if (components.length > 0) {
    return <>{components}</>;
  }

  return (
    <Stack gap={1}>
      <Typography variant="h6">Meta</Typography>
      <Typography>
        Meta settings are only available for specific fields. This field type is
        not compatible with meta configuration.
      </Typography>
    </Stack>
  );
}
